/** 칸이 화면 가까이 왔는가 — 목록·모니터링의 무거운 칸(영상 장면·HTML 미리보기)을 보이는 것만 띄운다. */
import { useEffect, useState } from 'react';

/** 칸이 화면 가까이 오면 참이 되고 그대로 남는다. 한 번 뜬 것은 다시 숨기지 않는다. */
export function useNearViewport(ref: React.RefObject<HTMLElement | null>): boolean {
  const [near, setNear] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element || near) return;
    if (typeof IntersectionObserver === 'undefined') {
      setNear(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setNear(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, near]);
  return near;
}
